import { ENDPOINTS } from "../config/endpoints/stage";
import { apiFailureErrorMessage, HttpService } from "../utils";

export class ReferralService {
  constructor(private httpService: HttpService) {}

  async getReferralUrl() {
    const url = `${ENDPOINTS.ROOT}/referral/code`;
    try {
      const { data } = await this.httpService.get<any>(url);
      return data;
    } catch (error) {
      throw new Error(apiFailureErrorMessage);
    }
  }

  async getReferralData() {
    const url = `${ENDPOINTS.ROOT}/referral/getReferredUsers`;
    try {
      const { data } = await this.httpService.get<any>(url);
      return data;
    } catch (error) {
      throw new Error(apiFailureErrorMessage);
    }
  }

  async potentialReferral(fullName:string,email:string,phoneNumber:any) {
    const url = `${ENDPOINTS.ROOT}/referral/potential-referral`;
    try {
      const ph = parseInt(phoneNumber)
      const { data } = await this.httpService.post<any>(url,{ data: {
        fullName,email,phoneNumber:ph
      } });
      return data;
    } catch (error) {
      throw error;
    }
  }
}
